import { styled } from '@linaria/react';

export const PictureImage = styled.img`
  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: -o-crisp-edges; /* Opera */
  image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
`;

export const PictureContainer = styled.picture`
  width: inherit;
  height: inherit;
`;
